import React, {useEffect, useState} from "react";
import {
  Form,
  Row,
  Col,
  Space,
  DatePicker,
  Input,
  Button,
  Spin,
  message,
} from "antd";
import {catalogService, pharmacyStoreService, storeService} from "api";
import {InputFields} from "components/common";
import {dataFields} from "./config";
import Notification from "components/common/notification/notification";
import {
  convertDateStringToDateTimezone_7,
  convertIosStringToDateDayjs,
  formatDate,
  formatDateToStringTimezone_7,
  randomId,
} from "helper/common";
import {FORMAT_TIME} from "types/enums";
import { fieldsInit } from "../../Medicine/ModalContent/config";

const ModalContent = props => {
  const {data, closeModal, type, getListBidDecision, nameCatalog} = props;
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [fields, setFields] = useState(dataFields);
  useEffect(() => {
    if (type == "Thêm") {
      form.resetFields();
    } else {
      console.log(data);
      form.setFieldsValue({
        ...data,
        tuNgay: convertDateStringToDateTimezone_7(data?.tuNgay),
        denNgay: convertDateStringToDateTimezone_7(data?.denNgay),
        hanSYT: convertDateStringToDateTimezone_7(data?.hanSYT),
      });
      form.setFieldValue("medicineIds", data?.bidMedicineDtos?.[0]?.medicineId);
      
    }
  }, [data]);
  useEffect(() => {
     getListThuoc();
     getListMedicineGroup()
     getListSubstance()
     getListDuongDung()
     getListMedicineType()
     getListUnit()
     getListBaoChe()
  }, []);
  const formatData = () => {
    return {
      ...form.getFieldsValue(),
      id: type === "Sửa" ? data.id : null, 
      tuNgay: formatDate(form.getFieldValue("tuNgay")),
      denNgay: formatDate(form.getFieldValue("denNgay")),
    };
  };
 
  const addBidDecision = async () => {
    setLoading(true);
    try {
      const data = formatData();
      console.log("data", data);
      const res = await pharmacyStoreService.addBidDecision(data);
      console.log("add", res);
      setLoading(false);
      closeModal();
      Notification("success", `Đã thêm ${nameCatalog} mới`);
      await getListBidDecision();
    } catch (error) {
      setLoading(false);
      Notification(
        "error",
        error?.response?.data ?? `Đã có lỗi khi thêm mới ${nameCatalog}`
      );
    }
  };
  const editBidDecision = async () => {
    setLoading(true);
    try {
      const data = formatData();
      const res = await pharmacyStoreService.addBidDecision(data);
      console.log("edit", res);
      setLoading(false);
      Notification("success", `Đã sửa thông tin ${nameCatalog}`);

      closeModal();
      await getListBidDecision();
    } catch (error) {
      setLoading(false);
      Notification(
        "error",
        error?.response?.data ?? `Đã có lỗi khi sửa thông tin ${nameCatalog}`
      );
    }
  };
    const getListThuoc = async () => {
      try {
        const res = (await storeService.getListMedicineByParams({})) || [];
        dataFields.find(e => e.name == "medicineIds").options = res.map(e => {
          return {key: randomId(), value: e?.id, label: e?.name};
        });
        setFields([...dataFields]);
      } catch (error) {}
    };
  const getListMedicineGroup = async () => {
    try {
      const res = await pharmacyStoreService.getListMedicineGroup(1, 100);
      dataFields.find(e => e.name == "nhomThuocId").options = res.data.map(
        e => ({key: randomId(), value: {id: e.id, name: e.name}, label: e.name})
      );
      setFields([...dataFields]);
    } catch (error) {
    }
  };
  const getListSubstance = async () => {
    try {
      const res = await pharmacyStoreService.getListSubstance(1, 200);
      dataFields.find(e => e.name == "idHoatChat").options = res.data.map(
        e => ({value:e.id, label: e.name})
      );
      setFields([...dataFields]);
    } catch (error) {
      Notification("error", `Đã có lỗi khi lấy danh sách Hoạt chất`);
    }
  };
  const getListDuongDung = async () => {
    try {
      const res = await catalogService.getListDuongDung();
      dataFields.find(e => e.name == "idDuongDung").options = res?.data?.map(
        e => ({
          value: e.id,
          label: e.name,
        })
      );
      setFields([...dataFields]);
    } catch (error) {}
  };
  const getListMedicineType = async () => {
    try {
      const res = await pharmacyStoreService.getListMedicineType(1, 50);
      dataFields.find(e => e.name == "loaiThuoc").options = res.data.map(
        e => ({key: randomId(), value: e.name, label: e.name})
      );
      setFields([...dataFields]);
    } catch (error) {
      Notification("error", `Đã có lỗi khi lấy danh sách loại thuốc`);
    }
  };
  const getListUnit = async () => {
    try {
      const res = await catalogService.getListUnit();
      dataFields.find(e => e.name == "idDonViTinh").options = res.data.map(
        e => ({key: randomId(), value: e.id, label: e.name})
      );
      
      setFields([...dataFields]);
    } catch (error) {
      Notification("error", `Đã có lỗi khi lấy danh sách đơn vị chuyển đổi`);
    }
  };
  const getListBaoChe = async () => {
    try {
      const res = await pharmacyStoreService.getDangBaoChe();
      dataFields.find((e) => e.name == "idDangBaoChe").options =  res?.data?.map((e) => ({
        value: e.id,
        label: e.name,
      }));
    
      setFields([...dataFields]);
    } catch (error) {}
  };
  const onFinish = values => {
    if (type == "Thêm") {
      addBidDecision();
    } else {
      editBidDecision();
    }
  };
  return (
    <div>
      <Spin spinning={loading}>
        <Form form={form} onFinish={onFinish}>
          <Space direction="vertical" style={{width: "100%"}}>
            <Row gutter={[16, 16]}>
              <InputFields data={fields}></InputFields>
            </Row>
            <Row justify="end">
              <Col>
                <Space>
                  <Button onClick={closeModal}>Hủy</Button>
                  <Button htmlType="submit" type="primary">
                    Xác nhận
                  </Button>
                </Space>{" "}
              </Col>
            </Row>
          </Space>
        </Form>
      </Spin>
    </div>
  );
};
export default ModalContent;
